<script>
import useLoading from '@/helpers/loading-effect';
import {onMounted, onUnmounted, ref} from 'vue';
import {WorkflowsRepository} from "@/services/workflows-repository";

export default {
  name: 'WorkflowLog',
  template: '#workflow-log-template',
  props: {
    uid: {
      type: String,
      required: true,
    },
    workflow: {
      type: Object,
      required: false,
    },
    node: {
      type: Object,
      required: false,
    },
  },
  setup(props) {
    const {
      isLoading,
      isLoaded,
      startLoading,
      stopLoading,
    } = useLoading();

    const {
      isLoading: isRefreshing,
      isLoaded: isRefreshed,
      startLoading: startRefreshing,
      stopLoading: stopRefreshing,
    } = useLoading(null);

    const log = ref([]);

    const autoRefresh = ref(false);

    const toggleAutoRefresh = () => {
      autoRefresh.value = !autoRefresh.value;
    }

    const interval = setInterval(async () => {
      if (autoRefresh.value) {
        startRefreshing();
        await fetch();
        stopRefreshing()
      }
    }, 5 * 1000)

    const fetch = async () => {
      log.value = await WorkflowsRepository.getWorkflowLog(props.uid, props.node?.uid);
    };

    onMounted(async () => {
      startLoading();
      await fetch();
      stopLoading();
    });

    onUnmounted(() => clearInterval(interval));

    const levelTextColors = {
      info: 'text-info',
      warn: 'text-warning',
      error: 'text-danger',
      debug: 'text-secondary',
      success: 'text-success',
    };

    const levelBackgroundColors = {
      info: 'bg-info-light',
      warn: 'bg-warning-light',
      error: 'bg-danger-light',
      debug: 'bg-light',
      success: 'bg-success-light',
    };

    return {
      isLoaded,
      isLoading,
      log,
      autoRefresh,
      toggleAutoRefresh,
      isRefreshing,
      isRefreshed,
      levelTextColors,
      levelBackgroundColors
    };
  },
};
</script>
